import React from 'react';
import ReactDOM from 'react-dom';
import { createStore } from 'redux';
import { Provider } from 'react-redux';

import './index.css';
import App from './App';
import betsApp from './reducers/rootReducers'
import * as serviceWorker from './serviceWorker';
import { gsntvIframeCommunicationInit } from './utils/gsntv';
// import { updateWheelPrize, updateSpinStatus, wheelSpinning } from './actions/wheel';

const store = createStore(
  betsApp, 
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

// TEST reducers
// console.log('store', store.getState());

// const unsubscribe = store.subscribe(()=>console.log(store.getState()));

// store.dispatch(updateWheelPrize('money'));
// store.dispatch(updateSpinStatus(true));
// store.dispatch(wheelSpinning(true));

// unsubscribe();

gsntvIframeCommunicationInit();

ReactDOM.render(
  <Provider store={store}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
